import {
  frameThickness,
  glassHingeWidth,
  glassHingeHeight,
  glassLockWidth,
  glassLockHeight,
} from '@/shared/config/model-constants'
import type { ModelData } from '@/shared/stores/model-utils'

export const model2_2InitialModel: ModelData = {
 name: 'Variant 6',
  modelId: 'model2_2',
  type: 'DOOR',
  description: 'Variant 6',
  width: 2400,
  height: 3100,
  photoId: null,
  serviceNames: [],
  serviceIds: [],
  
  parameters: [
    {
      positionId: "top_frame_profile",
      type: "PROFILE",
      width: 2400,
      height: frameThickness,
      thickness: 2,
      color: "#ffffff",
      position: { x: 0, y: 0, z: 0 },
      hardware: null,
      comment: null,
      isDouble: null,
    },
    {
      positionId: "bottom_left_frame_profile",
      type: "PROFILE",
      width: 400,
      height: frameThickness,
      thickness: 2,
      color: "#ffffff",
      position: { x: 0, y: 3040, z: 0 },
      hardware: null,
      comment: null,
      isDouble: null,
    },
    {
      positionId: "bottom_right_frame_profile",
      type: "PROFILE",
      width: 400,
      height: frameThickness,
      thickness: 2,
      color: "#ffffff",
      position: { x: 2000, y: 3040, z: 0 },
      hardware: null,
      comment: null,
      isDouble: null,
    },
    {
      positionId: "left_frame_profile",
      type: "PROFILE",
      width: frameThickness,
      height: 3100,
      thickness: 2,
      color: "#ffffff",
      position: { x: 0, y: 0, z: 0 },
      hardware: null,
      comment: null,
      isDouble: null,
    },
    {
      positionId: "right_frame_profile",
      type: "PROFILE",
      width: frameThickness,
      height: 3100,
      thickness: 2,
      color: "#ffffff",
      position: { x: 2340, y: 0, z: 0 },
      hardware: null,
      comment: null,
      isDouble: null,
    },

    {
      positionId: "left_glass_panel",
      type: "GLASS",
      width: 340,
      height: 2980,
      thickness: 6,
      color: "rgba(0, 0, 255, 0.1)",
      position: { x: frameThickness, y: frameThickness, z: 0 },
      isDouble: false,
      hardware: null,
    },
    {
      positionId: "top_door_glass_panel",
      type: "GLASS",
      width: 1600,
      height: 780,
      thickness: 6,
      color: "rgba(0, 0, 255, 0.1)",
      position: { x: 400, y: frameThickness, z: 0 },
      isDouble: false,
      hardware: null,
    },

    {
      positionId: "door_glass_panel_1",
      type: "GLASS",
      width: 800,
      height: 2260,
      thickness: 6,
      color: "rgba(0, 0, 255, 0.1)",
      position: { x: 400, y: 840, z: 0 },
      isDouble: false,
      hardware: {
        handles: [
          {
            positionId: 'left_vertical_handle',
            type: 'VERTICAL_HANDLE',
            width: 40,
            height: 200,
            thickness: 10,
            color: '#ffffff',
            material: '',
            materialId: null,
            position: { x: 740, y: Math.round(2260 * 0.47), z: 10 },
          },
        ],
        hinges: [
          {
            positionId: 'door_1_left_top_hinge_1',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            position: {
              x: -glassHingeWidth / 3,
              y: -glassHingeHeight / 2,
              z: 10,
            },
          },
          {
            positionId: 'door_1_left_bottom_hinge_2',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            position: {
              x: 0,
              y: 2260 - glassHingeHeight,
              z: 10,
            },
          },
        ],
        locks: [
          {
            positionId: 'door_1_right_lock',
            type: 'LOCK',
            width: glassLockWidth,
            height: glassLockHeight,
            thickness: 10,
            color: '#C0C0C0',
            position: {
              x: 800 - glassLockWidth * 1.5,
              y: 2260 - glassLockHeight,
              z: 10,
            },
          },
        ],
      },
    },

    {
      positionId: "door_glass_panel_2",
      type: "GLASS",
      width: 800,
      height: 2260,
      thickness: 6,
      color: "rgba(0, 0, 255, 0.1)",
      position: { x: 1200, y: 840, z: 0 },
      isDouble: false,
      hardware: {
        handles: [
          {
            positionId: 'right_vertical_handle',
            type: 'VERTICAL_HANDLE',
            width: 40,
            height: 200,
            thickness: 10,
            color: '#ffffff',
            material: '',
            materialId: null,
            position: { x: 30, y: Math.round(2260 * 0.47), z: 10 },
          },
        ],
        hinges: [
          {
            positionId: 'door_2_right_top_hinge_1',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            position: {
              x: 800 - glassHingeWidth / 2,
              y: -glassHingeHeight / 2,
              z: 10,
            },
          },
          {
            positionId: 'door_2_right_bottom_hinge_2',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            position: {
              x: 800 - glassHingeWidth,
              y: 2260 - glassHingeHeight,
              z: 10,
            },
          },
        ],
        locks: [
          {
            positionId: 'door_2_left_lock',
            type: 'LOCK',
            width: glassLockWidth,
            height: glassLockHeight,
            thickness: 10,
            color: '#C0C0C0',
            position: {
              x: glassLockWidth,
              y: 2260 - glassLockHeight,
              z: 10,
            },
          },
        ],
      },
    },

    {
      positionId: "right_glass_panel",
      type: "GLASS",
      width: 340,
      height: 2980,
      thickness: 6,
      color: "rgba(0, 0, 255, 0.1)",
      position: { x: 2000, y: frameThickness, z: 0 },
      isDouble: false,
      hardware: null,
    },
  ],
  doorConfiguration: {
    type: "double_door_with_fixed_panels",
    totalDoorWidth: 1600,
    individualDoorWidth: [800, 800],
    totalHandles: 2,
    hingePosition: "left_and_right",
    openingDirection: "inward_and_outward_swing",
  },
}
